import React from 'react';
import {ConstraintDataPlugin, ConstraintPluginProps} from '../ConstraintDataPlugin';
import {
    ConstraintType,
    DataTypeConstraintDto,
    IntegerRangeConstraintDataDto
} from '../../../../../../common/apis/datatype/DataTypeConstraintDto';
import {CoreDataType} from "../../../../../../common/apis/datatype/DataTypeDefinitionDto";
import {DataTypeTranslationKey} from "../../DataTypeTranslationKey";
import {IntegerRangeConstraintPluginForm} from "./IntegerRangeConstraintPluginForm";
import {TranslationFunction} from "../../../../../../store/localization/TranslMessasge";
import {ConstraintValueValidationPlugin} from "../ConstraintValueValidationPlugin";
import {CommonTranslationKey} from "../../../CommonTranslationKey";
import {StereotypesTranslationKey} from "../../../stereotypes/StereotypesTranslationKey";

export class IntegerRangeConstraintPlugin implements ConstraintDataPlugin<IntegerRangeConstraintDataDto>, ConstraintValueValidationPlugin {
    readonly type = ConstraintType.INTEGER_RANGE;

    getSupportedDataTypes(): CoreDataType[] {
        return [
            CoreDataType.INTEGER
        ];
    }

    getInitialData(): IntegerRangeConstraintDataDto {
        return {
            type: ConstraintType.INTEGER_RANGE,
            min: 0,
            max: 100
        };
    }

    render(props: ConstraintPluginProps<IntegerRangeConstraintDataDto>): React.ReactElement {
        return <IntegerRangeConstraintPluginForm {...props} />;
    }

    validate(data: IntegerRangeConstraintDataDto, coreDataType: CoreDataType): Record<string, string> {
        const errors: Record<string, string> = {};

        if ((data.min === null || data.min === undefined) && (data.max === null || data.max === undefined)) {
            errors.min = DataTypeTranslationKey.AT_LEAST_ONE_OF_MIN_OR_MAX_MUST_BE_SPECIFIED;
        } else if (data.min && data.max && data.min > data.max) {
            errors.min = DataTypeTranslationKey.MIN_VALUE_MUST_BE_LESS_THAN_OR_EQUAL_TO_MAX;
        }

        return errors;
    }

    getConstraintExpression(data: IntegerRangeConstraintDataDto): string {
        const {min, max} = data;

        if (min === undefined && max === undefined) return "";

        const left = min !== null && min !== undefined ? min.toFixed(0) : "-∞";
        const right = max !== null && max !== undefined ? max.toFixed(0) : "∞";

        return `<${left}, ${right}>`;
    }

    validateValue(value: any, attributeId: string, constraint: DataTypeConstraintDto, t: TranslationFunction): Record<string, string> {
        const constraintData = constraint.constraintData as IntegerRangeConstraintDataDto;
        const {min, max} = constraintData;

        if (!value && value !== 0) {
            return this.errorResult(t(CommonTranslationKey.FILL_OUT_THIS_FIELD), attributeId);
        }

        const convertedValue = typeof value === 'number' ? value : Number(value);
        if (isNaN(convertedValue) || !Number.isInteger(convertedValue)) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_NOT_VALID_INTEGER), attributeId);
        }

        if (min != null && convertedValue < min) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_BELLOW_ALLOWED_LIMIT), attributeId);
        }
        if (max != null && convertedValue > max) {
            return this.errorResult(t(StereotypesTranslationKey.VALUE_IS_ABOVE_ALLOWED_LIMIT), attributeId);
        }

        return {};
    }

    private errorResult(error: string, attributeId: string) {
        return {
            [attributeId]: error
        };
    }
}
